@import '../styles/palette.scss';
@import '../styles/fonts.scss';
@import '../styles/mixins.scss';
@import '../styles/deviceBreakpoints.scss';

.space40 {
  @include space(40);
}

.activities {
  @include barlow(16);
  @include target(tablet) {
    @include barlow(14);
  }

  h2 {
    @include merriweather(20);
    margin: 20px 0;

    @include target(tablet) {
      @include merriweather(16);
    }
  }
}
